import { fetchWithAuth } from '../auth/fetchWithAuth';
import { notifyError, notifySuccess } from '../components/Toast';
import { APP_STATES } from '../enums/AppStates';
const API_REPORTES_URL = `${process.env.REACT_APP_API_BASE_URL}reportes`;

export const fetchActiveProcesses = (unitId,unitSede,user)  => {
  return async (dispatch) => {

    dispatch({ type: 'FETCH_PROCESS_REQUEST' });

    try {

      const params = new URLSearchParams({
        unidadGestion: unitId ?? '',
        sede: unitSede ?? '',
      }).toString();

      const response = await fetchWithAuth(`${API_REPORTES_URL}/procesos?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        const data = await response.json();
        
        const activeProcess = [];
        const historicalProcess = [];
        
        for (const proceso of data) {
          const codigoEstado = proceso?.estado?.Id.toUpperCase();

          if (codigoEstado === APP_STATES.ACTIVO) {
            activeProcess.push(proceso);
          } else if (codigoEstado === APP_STATES.HISTORICO) {
            historicalProcess.push(proceso);
          }
        }
        
        activeProcess.sort((a, b) => new Date(b.dt_inserttime) - new Date(a.dt_inserttime));
        historicalProcess.sort((a, b) => new Date(b.dt_inserttime) - new Date(a.dt_inserttime));

        dispatch({
          type: 'FETCH_PROCESS_SUCCESS',
          payload: {
            actives: activeProcess,
            historical: historicalProcess,
          }
        });

      } else {
        const errorData =  response.text();
        dispatch({ type: 'FETCH_PROCESS_FAIL', payload: errorData });
      }
    } catch (error) {
      dispatch({ type: 'FETCH_PROCESS_FAIL', payload: error.message });
    }
  }
};

export const loadProcesses = (unitId,unitSede,user) => {
  return async (dispatch) => {
    dispatch({ type: 'LOAD_PROCESSES_REQUEST' });

    try {
      
      const params = new URLSearchParams({
        unidadGestion: unitId ?? '',
        sede: unitSede ?? '',
      }).toString();

      const response = await fetchWithAuth(`${API_REPORTES_URL}/procesos?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      }, dispatch);

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: 'LOAD_PROCESSES_SUCCESS', payload: data });
      } else {
        const errorData = await response.text();
        dispatch({ type: 'LOAD_PROCESSES_FAIL', payload: errorData });
      }
    } catch (error) {
      dispatch({ type: 'LOAD_PROCESSES_FAIL', payload: error.message });
    }
  };
};

export const saveProcess = (process,user) => {
  return async (dispatch) => {
    dispatch({ type: 'SAVE_PROCESS_REQUEST' });
    try {
      const response = await fetchWithAuth(`${API_REPORTES_URL}/procesos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
        body: JSON.stringify(process)
      },dispatch);

      if (!response.ok) {
        const errorData = await response.json();
        notifyError(errorData.Message || 'Hubo un error al guardar el proceso');
        dispatch({ type: 'SAVE_PROCESS_FAIL', payload: errorData.Message });
      }

      dispatch(loadProcesses(null,null,user));
      dispatch({ type: 'SAVE_PROCESS_SUCCESS' });

    } catch (error) {
      notifyError('Hubo un error al guardar el proceso');
      dispatch({ type: 'SAVE_PROCESS_FAIL', payload: error.message });
    }
  };
};

export const deleteProcess = (processId,user) => {
  return async (dispatch) => {
    dispatch({ type: 'DELETE_PROCESS_REQUEST' });

    try {
      const response = await fetchWithAuth(`${API_REPORTES_URL}/procesos/${processId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        }
      },dispatch);
      
      if (response.ok) {
        dispatch(loadProcesses(null,null,user));
        notifySuccess('Proceso eliminado exitosamente');
        dispatch({ type: 'DELETE_PROCESS_SUCCESS' });
      } else {
        const errorData = await response.text();
        notifyError('Hubo un error al eliminar el proceso');
        dispatch({ type: 'DELETE_PROCESS_FAIL', payload: errorData });
      }
    } catch (error) {
      notifyError('Hubo un error al eliminar el proceso');
      dispatch({ type: 'DELETE_PROCESS_FAIL', payload: error.message });
    }
  };
};

export const updateProcessState = (processId,stateId,user) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATE_PROCESS_STATE_REQUEST' });

    try {
      const response = await fetchWithAuth(`${API_REPORTES_URL}/procesos/${processId}/estado/${stateId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        dispatch(loadProcesses(null,null,user));
        dispatch({ type: 'UPDATE_PROCESS_STATE_SUCCESS' });
      } else {
        const errorData = await response.text();
        notifyError('Hubo un error al actualizar el estado');
        dispatch({ type: 'UPDATE_PROCESS_STATE_FAIL', payload: errorData });
      }
    } catch (error) {
      notifyError('Hubo un error al actualizar el estado');
      dispatch({ type: 'UPDATE_PROCESS_STATE_FAIL', payload: error.message });
    }
  };
};

export const SelectProcess = (process) => {
  return (dispatch) => {
    dispatch({ type: 'PROCESS_CHANGED_CLEAR_STATE' });

    dispatch({
      type: 'SET_SELECTED_PROCESS',
      payload: process,
    });
  };
};

export const loadStages = (id,idParent,type,user) => {
  return async (dispatch) => {
    dispatch({ type: 'LOAD_STAGES_REQUEST' });

    try {
      
      const params = new URLSearchParams({
        idEtapa: id,
        idEtapaPadre: idParent,
        tipo: type ?? '',
      }).toString();

      const response = await fetchWithAuth(`${API_REPORTES_URL}/etapas/buscar?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      }, dispatch);

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: 'LOAD_STAGES_SUCCESS', payload: data });
      } else {
        const errorData = await response.text();
        dispatch({ type: 'LOAD_STAGES_FAIL', payload: errorData });
      }
    } catch (error) {
      dispatch({ type: 'LOAD_STAGES_FAIL', payload: error.message });
    }
  };
};

